module.exports = __webpack_public_path__ + "img/corporalTroop.413b1aff.png";